var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M9 .5c2.528 0 4.643 2.211 4.643 5V6h2.48c.229 0 .425.155.482.37l.016.094.878 12.111c-.006 1.648-1.249 2.925-2.713 2.925H3.214C1.75 21.5.506 20.223.5 18.575l.879-12.111A.5.5 0 0 1 1.878 6h2.48v-.5c0-2.789 2.113-5 4.642-5Zm0 .375C6.566.875 4.643 2.981 4.643 5.5V6h8.714v-.5C13.357 2.981 11.434.875 9 .875Zm8.214 17.667-.001-.02-.947-11.687-.037-.46h-2.586v2.563c0 .135-.095.187-.143.187s-.143-.052-.143-.187V6.374H4.643v2.563c0 .135-.095.187-.143.187s-.143-.052-.143-.187V6.374H1.771l-.037.46-.947 11.688v.039c0 1.382 1.056 2.563 2.427 2.563h11.572c1.37 0 2.428-1.181 2.428-2.562z"
  })));
};
export default SvgCart;